import { render, staticRenderFns } from "./oPage.vue?vue&type=template&id=fe0277b4"
import script from "./oPage.vue?vue&type=script&lang=js"
export * from "./oPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports